/**
 * 项目进度实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Row,
    Col,
    message,
    DatePicker,
    Input,
    Select,
    Slider,
    ColorPicker,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    currentDate,
    presets,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';

const Option = Select.Option;
const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const { open, setOpen, record, action, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [phase, setPhase] = useState('');
    const [progress, setProgress] = useState(0);
    const [recordTime, setRecordTime] = useState(currentDate);
    const [nodeStatus, setNodeStatus] = useState(CNF.progressLogNodeStatus[1]);
    const [nodeColor, setNodeColor] = useState('#1677ff');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setPhase('');
        setProgress(0);
        setRecordTime(currentDate);
        setNodeColor(CNF.progressLogNodeStatus[1]);
        setNodeColor('#1677ff');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (open && record) {
            setPhase(record.phase);
            setProgress(record.progress);
            setRecordTime(record.record_time ? record.record_time : currentDate);
            setNodeStatus(record.node_status ? record.node_status : CNF.progressLogNodeStatus[1]);
            setNodeColor(record.node_color ? record.node_color : '#1677ff');
            if (action === CNF.actionName.UPDATE) {
                setDescription(record.description ? record.description : '');
            }
        }
    }, [open, record, action]);

    const ok = () => {
        //  参数校验
        if (recordTime === '') {
            messageApi.error('记录时间不能为空！');
            return;
        }
        if (description === '') {
            messageApi.error('进度说明不能为空！');
            return;
        }

        setLoading(true);

        let data = {
            phase: phase,
            progress: progress,
            record_time: recordTime,
            node_color: nodeColor,
            node_status: nodeStatus,
            description: description,
        }

        if (action === CNF.actionName.CREATE) {
            data.action = CNF.actionName.PROGRESS;
        }

        $.ajax({
            url: CNF.api + 'projects/' + (action === CNF.actionName.CREATE ? 'details' : 'progressLogs') + '/' + record.key,
            headers: AddRequestHeaders(),
            type: action === CNF.actionName.CREATE ? 'PATCH' : 'PUT',
            dataType: 'JSON',
            data: JSON.stringify(data),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };

    const marks = {
        0: "0",
        50: "50",
        70: "70",
        80: "80",
        90: "90",
        100: {
            style: {
                color: "#008B00",
            },
            label: <strong>100</strong>,
        },
    };
    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={record ? record.name : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>项目阶段</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                style={{ width: '100%' }}
                                value={phase}
                                onChange={(value) => {
                                    setPhase(value);
                                    if (value === CNF.projectPhases[4].value) {
                                        setProgress(70);
                                    } else if (value === CNF.projectPhases[5].value) {
                                        setProgress(90);
                                    }
                                }}
                                disabled={loading}
                            >
                                {
                                    CNF.projectPhases.map((item) => {
                                        return <Option key={item.value} value={item.value}>{item.key}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>项目进度</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Slider
                                marks={marks}
                                value={progress}
                                onChange={(value) => setProgress(value)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>记录时间</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>节点状态</Text><Text type='danger'>*</Text></Col>
                    </Row>
                    <Row>
                        <Col span={11}>
                            <DatePicker
                                placeholder='记录时间'
                                style={{ width: '100%' }}
                                value={dayjs(recordTime, 'YYYY-MM-DD')}
                                onChange={(_, dateString) => setRecordTime(dateString)}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={11} offset={2} >
                            <Select
                                style={{ width: '100%' }}
                                options={CNF.progressLogNodeStatus.map((item) => ({
                                    lable: item,
                                    value: item,
                                }))}
                                disabled={loading}
                                value={nodeStatus}
                                onChange={(value) => setNodeStatus(value)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>节点颜色</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <ColorPicker
                                placement='right'
                                presets={presets}
                                value={nodeColor}
                                onChangeComplete={(value) => setNodeColor(value.toHexString())}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>进度说明</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 3, maxRows: 6 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity